//
import endpoints from '../endpoints';
import WebMethodService from '../WebMethodService';

class PersonalizationAPI {

  /**
   * Restituisce impostazioni di customizzazione lista
   * @param {number} idList 
   * @returns {Promise}
   * 
   */
  static getListSettings(idList) {
    const params = {
      idList
    };
    return WebMethodService.callWebMethod(endpoints.personalization.getListSettings, params);
  }


}

export default PersonalizationAPI;